export default class OrderForm {
  constructor() {
    this.tax = this._getTax();
    this.subtotalElement = document.getElementById('subtotal');
    this.totalElement = document.getElementById('total');
    this.taxElement = document.getElementById('tax');

    this._attachCounterChangeHandler();
    this._attachClickHandler();

    this._calculate();
  }

  _getTaxElement() {
    return document.querySelector('[data-tax]');
  }

  _getTax() {
    const taxElement = this._getTaxElement();
    const taxValue = taxElement ? parseInt(taxElement.dataset.tax) : 0;
    return 1 + taxValue/100;
  }

  _calculate() {
    let subtotal = 0;
    let total = 0;
    const plugin = this;
    const counters = document.querySelectorAll('[data-counter]');

    counters.forEach(function(counter) {
      const price = parseFloat(counter.dataset.price);
      const count = parseInt(counter.value);

      if (price > 0 && count > 0) {
        subtotal += price * count;
        total = subtotal * plugin.tax;
      }

      plugin.subtotalElement.textContent = subtotal > 0 ? subtotal.toFixed(2) : 0;
      plugin.totalElement.textContent = total > 0 ? total.toFixed(2) : 0;
      plugin.taxElement.textContent = total > 0 ? (total - subtotal).toFixed(2) : 0;
    });
  }

  // Event handlers
  _handleCounterChange(event) {
    if ('counter' in event.target.dataset) {
      const counter = event.target;

      if (counter.value === '') {
        counter.value = '0';
        this._calculate();
      }
    }
  }

  _handleStepClick(event) {
    if (event.target.dataset.step) {
      const button = event.target;
      const step = parseInt(button.dataset.step);
      const counter = document.getElementById(button.dataset.control);
      const value = parseInt(counter.value);
      const min = parseInt(counter.getAttribute('min'));
      const max = parseInt(counter.getAttribute('max'));
      let newValue = value;

      if (step === 1) {
        if (value < max) {
          newValue = value + step;
        }
      } else if (step === -1) {
        if (value > min) {
          newValue = value + step;
        }
      }

      counter.value = newValue;
      this._calculate();
    }
  }

  // Attach events
  _attachCounterChangeHandler() {
    document.addEventListener('change', this._handleCounterChange.bind(this));
    document.addEventListener('blur', this._handleCounterChange.bind(this));
    document.addEventListener('paste', this._handleCounterChange.bind(this));
  }

  _attachClickHandler() {
    document.addEventListener('click', this._handleStepClick.bind(this));
  }
}



// WEBPACK FOOTER //
// ./scripts/components/order-form.js